export default {
  OPEN: "open",
  Rr: "purchase",
  hr: "push_click",
  Ee: "custom_event",
  Bo: "iam_click",
  Bs: "test",
};
